export enum PromotionCodeType {
  amount = "amount",
  percentage = "percentage",
}
export interface Coupon {
  amount_off: number;
  percent_off: number;
  type: PromotionCodeType;
}

export interface PromotionCodeDTO {
  code: string;
  coupon: Coupon;
  id: string;
}

export interface PromotionCodeAttrs {
  campaignName: string;
  code: string;
  coupon: Coupon;
  id: string;
}

export class PromotionCode implements PromotionCodeAttrs {
  private readonly _campaignName: string;
  private readonly _code: string;
  private readonly _coupon: Coupon;
  private readonly _id: string;

  constructor(attrs: PromotionCodeAttrs) {
    this._campaignName = attrs.campaignName;
    this._code = attrs.code;
    this._coupon = attrs.coupon;
    this._id = attrs.id;
  }

  get campaignName(): string {
    return this._campaignName;
  }

  get code(): string {
    return this._code;
  }

  get coupon(): Coupon {
    return this._coupon;
  }

  get type(): PromotionCodeType {
    return this._coupon.type;
  }

  get id(): string {
    return this._id;
  }

  get isAmountCoupon(): boolean {
    return this.type === PromotionCodeType.amount;
  }
}
